var _defs, _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHuaweiAppgallery2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "huawei-appgallery-2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fb6361"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ed3e45"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_27740",
    "data-name": "Path 27740",
    d: "M10.1,0C2.7,0,0,2.7,0,10.1V25.9C0,33.295,2.7,36,10.1,36H25.894C33.29,36,36,33.295,36,25.9V10.1C36,2.7,33.295,0,25.9,0Z",
    fillRule: "evenodd",
    fill: "url(#linear-gradient)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_22449",
    "data-name": "Group 22449"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27741",
    "data-name": "Path 27741",
    d: "M15.7,20.88h1.445l-.725-1.687Zm-.356.85-.429.98h-.976L16.018,18h.844l2.068,4.71h-1l-.423-.98Zm15.71.977H32V18h-.944ZM27.3,20.685h1.74v-.858H27.3v-.965h2.525V18H26.357V22.71h3.559v-.859H27.3Zm-3.749.556L22.482,18H21.7l-1.07,3.24L19.591,18H18.573l1.643,4.71h.791l1.072-3.094,1.071,3.094h.8L25.587,18h-.992ZM12.5,20.7c0,.766-.38,1.175-1.072,1.175s-1.077-.42-1.077-1.208V18H9.4V20.7a1.869,1.869,0,0,0,2.02,2.085,1.9,1.9,0,0,0,2.04-2.125V18H12.5ZM7.115,18h.956v4.713H7.115V20.8H4.956v1.914H4V18h.956v1.9h2.16ZM18,12a6.007,6.007,0,0,1-6-6h.848a5.152,5.152,0,0,0,10.3,0H24a6.007,6.007,0,0,1-6,6",
    fill: "#fff",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHuaweiAppgallery2);
export default __webpack_public_path__ + "static/media/huawei-appgallery-2.0770c3390fa18567dcca3b228c0dfe1c.svg";
export { ForwardRef as ReactComponent };